import { createContext } from 'react';

export interface Features {
  [key: string]: boolean;
}

export interface FeaturesContextType {
  features: Features;
}

const FeaturesContext = createContext<FeaturesContextType>({
  features: {},
});

export default FeaturesContext;
